let ResourcesConstants
if (window.__ENV__ === 'PRODUCTION') {
  // set production variables the app needs here
  ResourcesConstants = {
    ATTACHMENTS_API: 'https://attachments.drift-files.com',
    LOGIN_APP_URL: 'https://start.drift.com',
    CONVERSATION_API: 'https://conversation.api.drift.com',
    LIVE_API: 'https://audiences.api.drift.com',
    CUSTOMER_API: 'https://customer.api.drift.com',
    WIDGET_CACHE_API: 'https://widget-cache.api.drift.com',
    INTEGRATION_API: 'https://integration.api.drift.com',
    INTEGRATION_SYNC_SCHEDULER_API:
      'https://integration-sync-scheduler.drift.com',
    GDPR_API: 'https://gdpr.api.drift.com',
    EVENT_API: 'https://event.api.drift.com',
    EMAIL_API: 'https://email.api.drift.com',
    SENTRY_KEY: 'https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073',
    SENTRY_ENVIRONMENT: 'production',
    CLIENT_ID: 'iVxHr9naeG4gMm',
    DEFAULT_CLIENT_ID: '1UDhLV0zBBVZo3',
    RECURLY_PUBLIC_KEY: 'sjc-6qRVjA5P3TB7IUmWbH5T1w',
    APP_URL: 'https://app.drift.com',
    HUBSPOT_CLIENT_ID: '85983271-b649-11e5-8278-55034748c042',
    MICROSOFT_DYNAMICS_CLIENT_ID: 'f01e4ea7-8d17-4fa4-8aea-a7c08f053a29',
    SLACK_CLIENT_ID: '207155666705.19007622051',
    MAILCHIMP_CLIENT_ID: '837579769361',
    SEGMENT_ID: 'YXwH8WAoOobo2Fa0YwXM5a1Ag09H7LXX',
    SPLIT_ID: 'sgqrbfcfvcomh9u28tb74rbp8ioriq1hi9em',
    GROWSUMO_ID: 'pk_9XDAo1SzQnD3utfb9Qw2QWUQp0QclncW',
    LINKEDIN_KEY: 'f4D5eGo195C5',
    SALESFORCE_CLIENT_ID:
      '3MVG9szVa2RxsqBZFCVv80STGhsUljVx0NU6Rbhd3XRpRDgLUHOPMrukSA5h8XTJQE58gWrOASyz1_5BKDgqm',
    ELOQUA_APP_ID: '7b9eb6eb-05fc-4fb1-bae9-7aac8807e5d8',
    PARDOT_APP_ID: '8792ea99-b42e-476f-aca3-dc2de106de41',
    DRIP_CLIENT_ID:
      '421340432347708342c81a2825bcc8fe7c202a67cffc37597fb92bc21acd9bff',
    GOOGLE_API_KEY: 'AIzaSyCPuZY6GnyM06cW3r5x1f0ryQPuezi1rxg',
    GOOGLE_CLIENT_ID:
      '87492603950-u124kma19e32jh963uc9s3vsuujpm53k.apps.googleusercontent.com',
    MICROSOFT_CALENDAR_CLIENT_ID: '57aa99b9-8cd2-4c0e-9498-2d6749d33f3b',
    MICROSOFT_ADMIN_CONSENT_CLIENT_ID: '57aa99b9-8cd2-4c0e-9498-2d6749d33f3b',
    WORDPRESS_CLIENT_ID: '49621',
    SHOPIFY_INTEGRATION_URL: 'https://shopify-integration.drift.com',
    DRUPAL_PLUGIN_URL: 'https://www.drupal.org/project/drift',
    FREE_SUPPORT_INBOX_ID: 21653, // assumes org 1
    PRESENCE_API_BASE: 'https://ws.api.drift.com',
    PRESENCE_WSS_BASE: 'wss://ws.api.drift.com',
    MESSAGES_API_BASE: 'https://chat.api.drift.com',
    MESSAGES_WSS_BASE: 'wss://chat.api.drift.com',
    WS_CHAT_USE_SHARDS: true,
    WS_LIVE_USE_SHARDS: true,
    WS_CHAT_BASE: 'chat.api.drift.com',
    WS_LIVE_BASE: 'live.api.drift.com',
    WS_PUSH_BASE: 'push.api.drift.com',
    WS_NUM_SHARDS: 50,
    WS_WSS_PROTOCOL: 'wss',
    WS_API_PROTOCOL: 'https',
    SALES_INBOX_ID: 44, // assumes org 1
    SALES_USER_ID: 46894, // assumes org 1
    SEGMENT_TRACKING_BLACKLIST: [42653],
    AUTH_CLIENT_ID: 'adMFuOx4OVWsZa',
    SEQUENCE_ENROLL_URL: 'https://app.drift.com/sequence-enroll-modal',
    ONBOARDING_CLP_URL: 'https://now.drift.click/t/adoption-onboarding-2',
    HELP_URL: 'http://help.drift.com',
    METRICS_API_BASE: 'https://metrics.api.drift.com',
    HAS_INTEGRATED_HELP: true,
    FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 54308,
    PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 53556,
    SUPPORT_TICKET_INTERACTION_ID: 51833,
    INTEGRATION_INTERACTION_ID: 62594,
    DEVELOPERS_WEB_URL: 'https://dev.drift.com',
    DRIFT_VIDEO_URL: 'https://video.drift.com',
    SLACK_INTEGRATION_API: 'https://slack-integration-api.api.driftqa.com',
    SLACK2_CLIENT_ID: '896987540245.912898247671',
    MEETINGS_API: 'https://meetings.api.drift.com',
    SALESLOFT_INTEGRATION_API:
      'https://salesloft-integration-api.api.driftqa.com',
    SALESLOFT_CLIENT_ID:
      '257dea3c5820ba0945ff90a3a32ab57ec96a9ff1e146b285822e416242fae805',
  }
} else if (window.__ENV__ === 'MASTER') {
  ResourcesConstants = {
    ATTACHMENTS_API: 'https://attachments.driftqa-files.com',
    LOGIN_APP_URL: 'https://start.driftqa.com',
    CONVERSATION_API: 'https://conversation2.api.driftqa.com',
    LIVE_API: 'https://audiences.api.driftqa.com',
    CUSTOMER_API: 'https://customer2.api.driftqa.com',
    WIDGET_CACHE_API: 'https://widget-cache.api.driftqa.com',
    INTEGRATION_API: 'https://integration.api.driftqa.com',
    INTEGRATION_SYNC_SCHEDULER_API:
      'https://integration-sync-scheduler.driftqa.com',
    GDPR_API: 'https://gdpr.api.driftqa.com',
    EVENT_API: 'https://event2.api.driftqa.com',
    EMAIL_API: 'https://email.api.driftqa.com',
    SENTRY_KEY: 'https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073',
    SENTRY_ENVIRONMENT: 'qa',
    CLIENT_ID: 'HcVEwgp9wDnDvd',
    DEFAULT_CLIENT_ID: 'W41NvthhICG4VC',
    RECURLY_PUBLIC_KEY: 'ewr1-fmDG1UhLCwKGtrT8ngPluT',
    APP_URL: 'https://app.driftqa.com',
    HUBSPOT_CLIENT_ID: 'deca04e8-ba11-11e5-a2bf-bd028721085c',
    MICROSOFT_DYNAMICS_CLIENT_ID: 'f01e4ea7-8d17-4fa4-8aea-a7c08f053a29',
    LINKEDIN_KEY: 'f4D5eGo195C5',
    SALESFORCE_CLIENT_ID:
      '3MVG9ROcrWLs7Uy.IfGSef7LAlZZI7K5B1xDWHzS8bDALn6HjimzYTitkVJKQnLvM6SYlrptGd1m7mvVPreSc',
    ELOQUA_APP_ID: 'bd860ed3-837c-4117-8d2d-ee69261c7c52',
    PARDOT_APP_ID: '19e929a2-4213-4745-b022-24fe2aec81fc',
    SLACK_CLIENT_ID: '2411874785.19011013270',
    MAILCHIMP_CLIENT_ID: '492315023625',
    SEGMENT_ID: '26F56Q24FYGhT79jXwkS3Ax002VxcoCN',
    SPLIT_ID: 'ncjqpiao38jfrada4mtntpt0emgilspe6tqo',
    GROWSUMO_ID: 'pk_h0nHlMdhpluEk2ZVSpFWpHpIeJHNm9D5',
    DRIP_CLIENT_ID:
      '12f96245a2bf6246f6cde672e000f543d97973be5a0569557adb050eb1557d66',
    GOOGLE_API_KEY: 'AIzaSyCPuZY6GnyM06cW3r5x1f0ryQPuezi1rxg',
    GOOGLE_CLIENT_ID:
      '519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com',
    MICROSOFT_CALENDAR_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    MICROSOFT_ADMIN_CONSENT_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    WORDPRESS_CLIENT_ID: '49620',
    SHOPIFY_INTEGRATION_URL: 'https://shopify-integration.driftqa.com',
    DRUPAL_PLUGIN_URL: 'https://www.drupal.org/project/drift',
    FREE_SUPPORT_INBOX_ID: 10617,
    PRESENCE_API_BASE: 'https://ws.api.driftqa.com',
    PRESENCE_WSS_BASE: 'wss://ws.api.driftqa.com',
    MESSAGES_API_BASE: 'https://ws.api.driftqa.com',
    MESSAGES_WSS_BASE: 'wss://ws.api.driftqa.com',
    WS_CHAT_USE_SHARDS: true,
    WS_LIVE_USE_SHARDS: true,
    WS_CHAT_BASE: 'chat.api.driftqa.com',
    WS_LIVE_BASE: 'live.api.driftqa.com',
    WS_PUSH_BASE: 'push.api.driftqa.com',
    WS_NUM_SHARDS: 50,
    WS_WSS_PROTOCOL: 'wss',
    WS_API_PROTOCOL: 'https',
    SEGMENT_TRACKING_BLACKLIST: [],
    AUTH_CLIENT_ID: '9nuLTG38lZhx6E',
    SEQUENCE_ENROLL_URL: 'https://app.driftqa.com/sequence-enroll-modal',
    ONBOARDING_CLP_URL:
      'https://jackie-testing.driftqa.click/t/1e6df2ed-ddc8-42b3-8673-cb25a47e2200',
    SUPPORT_TICKET_INTERACTION_ID: 303381,
    METRICS_API_BASE: 'https://metrics.api.driftqa.com',
    HELP_URL: 'http://help.drift.com',
    HAS_INTEGRATED_HELP: false,
    FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 303531,
    PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 303411,
    INTEGRATION_INTERACTION_ID: 304300,
    DEVELOPERS_WEB_URL: 'https://dev.driftqa.com',
    DRIFT_VIDEO_URL: 'https://app-qa.video.drift.com',
    SLACK_INTEGRATION_API: 'https://slack-integration-api.api.drift.com',
    SLACK2_CLIENT_ID: '896987540245.886754672465',
    MEETINGS_API: 'https://meetings.api.driftqa.com',
    SALESLOFT_INTEGRATION_API:
      'https://salesloft-integration-api.api.drift.com',
    SALESLOFT_CLIENT_ID:
      '257dea3c5820ba0945ff90a3a32ab57ec96a9ff1e146b285822e416242fae805',
  }
  // Set whatever you want if you need to talk to other services.
} else {
  ResourcesConstants = {
    ATTACHMENTS_API: 'https://attachments.driftqa-files.com',
    LOGIN_APP_URL: 'https://start.driftqa.com',
    CONVERSATION_API: 'https://conversation2.api.driftqa.com',
    LIVE_API: 'https://audiences.api.driftqa.com',
    CUSTOMER_API: 'https://customer2.api.driftqa.com',
    WIDGET_CACHE_API: 'https://widget-cache.api.driftqa.com',
    INTEGRATION_API: 'https://integration.api.driftqa.com',
    INTEGRATION_SYNC_SCHEDULER_API:
      'https://integration-sync-scheduler.driftqa.com',
    GDPR_API: 'https://gdpr.api.driftqa.com',
    EVENT_API: 'https://event2.api.driftqa.com',
    CLIENT_ID: 'HcVEwgp9wDnDvd',
    DEFAULT_CLIENT_ID: 'W41NvthhICG4VC',
    RECURLY_PUBLIC_KEY: 'ewr1-fmDG1UhLCwKGtrT8ngPluT',
    APP_URL: 'http://localhost:8005', //set to https://localhost to run on https://localhost
    HUBSPOT_CLIENT_ID: '4eedba23-b951-11e5-a2bf-bd028721085c',
    MICROSOFT_DYNAMICS_CLIENT_ID: 'f01e4ea7-8d17-4fa4-8aea-a7c08f053a29',
    LINKEDIN_KEY: 'f4D5eGo195C5',
    SALESFORCE_CLIENT_ID:
      '3MVG9ROcrWLs7Uy.IfGSef7LAlZZI7K5B1xDWHzS8bDALn6HjimzYTitkVJKQnLvM6SYlrptGd1m7mvVPreSc',
    ELOQUA_APP_ID: 'bd860ed3-837c-4117-8d2d-ee69261c7c52',
    PARDOT_APP_ID: '19e929a2-4213-4745-b022-24fe2aec81fc',
    SLACK_CLIENT_ID: '2411874785.19011013270',
    MAILCHIMP_CLIENT_ID: '332460500253',
    SEGMENT_ID: '26F56Q24FYGhT79jXwkS3Ax002VxcoCN',
    SPLIT_ID: 'ncjqpiao38jfrada4mtntpt0emgilspe6tqo',
    GROWSUMO_ID: 'pk_h0nHlMdhpluEk2ZVSpFWpHpIeJHNm9D5',
    DRIP_CLIENT_ID:
      '12f96245a2bf6246f6cde672e000f543d97973be5a0569557adb050eb1557d66',
    GOOGLE_API_KEY: 'AIzaSyCPuZY6GnyM06cW3r5x1f0ryQPuezi1rxg',
    GOOGLE_CLIENT_ID:
      '519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com',
    MICROSOFT_CALENDAR_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    MICROSOFT_ADMIN_CONSENT_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    WORDPRESS_CLIENT_ID: '49619',
    SHOPIFY_INTEGRATION_URL: 'https://shopify-integration.driftqa.com',
    DRUPAL_PLUGIN_URL: 'https://www.drupal.org/project/drift',
    FREE_SUPPORT_INBOX_ID: 10617,
    PRESENCE_API_BASE: 'https://ws.api.driftqa.com',
    PRESENCE_WSS_BASE: 'wss://ws.api.driftqa.com',
    MESSAGES_API_BASE: 'https://ws.api.driftqa.com',
    MESSAGES_WSS_BASE: 'wss://ws.api.driftqa.com',
    WS_CHAT_USE_SHARDS: true,
    WS_LIVE_USE_SHARDS: true,
    WS_CHAT_BASE: 'chat.api.driftqa.com',
    WS_LIVE_BASE: 'live.api.driftqa.com',
    WS_PUSH_BASE: 'push.api.driftqa.com',
    WS_NUM_SHARDS: 50,
    WS_WSS_PROTOCOL: 'wss',
    WS_API_PROTOCOL: 'https',
    SEGMENT_TRACKING_BLACKLIST: [],
    AUTH_CLIENT_ID: 'HcVEwgp9wDnDvd',
    SEQUENCE_ENROLL_URL: 'https://app.driftqa.com/sequence-enroll-modal',
    ONBOARDING_CLP_URL:
      'https://jackie-testing.driftqa.click/t/1e6df2ed-ddc8-42b3-8673-cb25a47e2200',
    SUPPORT_TICKET_INTERACTION_ID: 303381,
    METRICS_API_BASE: 'https://metrics.api.driftqa.com',
    HELP_URL: 'http://help.drift.com',
    HAS_INTEGRATED_HELP: false,
    FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 303531,
    PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 303411,
    INTEGRATION_INTERACTION_ID: 304300,
    DEVELOPERS_WEB_URL: 'https://dev.driftqa.com',
    DRIFT_VIDEO_URL: 'https://localhost:8000',
    SLACK_INTEGRATION_API: 'https://slack-integration-api.api.drift.com',
    SLACK2_CLIENT_ID: '896987540245.886754672465',
    SALESLOFT_INTEGRATION_API:
      'https://salesloft-integration-api.api.drift.com',
    SALESLOFT_CLIENT_ID:
      '257dea3c5820ba0945ff90a3a32ab57ec96a9ff1e146b285822e416242fae805',
  }
}

export const DRIFTT_HOME_PAGE = 'https://www.drift.com'
export const APP_STORE_URL =
  'https://itunes.apple.com/us/app/drift-messaging-for-sales/id1117096112'
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.drift.android.drift'
export const APP_TITLE = 'Drift'
export const SERVER_SIDE_STYLE_ID = 'server-side-style'
export const REACT_CONTENT_ID = 'react-content'
export const ZENDESK_CLIENT_ID = 'drift-faq'
export const IFRAMELY_KEY = 'f0f2cc6ba50c77794e5c5eb2930f3fd5'

export const OUTREACH_CLIENT_ID =
  '08745ef78bd1fbe782f7b8317fd988201da78385ac3761d2dfe2d33a566f7c22'
export const YODEL_APP_ID = '659db0c9-178f-40a3-9017-278e54662732'
export const PIESYNC_APP_ID = 'ace8bfec-1fd2-4372-ba33-5792ce72e5af'

export const MARKETABLE_MOMENT_DATE = '2018-05-01 05:00 EDT'

export const ELOQUA_APP_ID = ResourcesConstants.ELOQUA_APP_ID
export const PARDOT_APP_ID = ResourcesConstants.PARDOT_APP_ID
// Drift made integrations on the developer platform (integration titles).
export const DRIFT_DEV_INTEGRATIONS = new Set(['Eloqua', 'Pardot', 'PieSync'])

export const ATTACHMENTS_API = ResourcesConstants.ATTACHMENTS_API
export const LOGIN_APP_URL = ResourcesConstants.LOGIN_APP_URL
export const CONVERSATION_API = ResourcesConstants.CONVERSATION_API
export const LIVE_API = ResourcesConstants.LIVE_API
export const CUSTOMER_API = ResourcesConstants.CUSTOMER_API
export const WIDGET_CACHE_API = ResourcesConstants.WIDGET_CACHE_API
export const INTEGRATION_API = ResourcesConstants.INTEGRATION_API
export const INTEGRATION_SYNC_SCHEDULER_API =
  ResourcesConstants.INTEGRATION_SYNC_SCHEDULER_API
export const GDPR_API = ResourcesConstants.GDPR_API
export const EVENT_API = ResourcesConstants.EVENT_API
export const SENTRY_KEY = ResourcesConstants.SENTRY_KEY
export const SENTRY_ENVIRONMENT = ResourcesConstants.SENTRY_ENVIRONMENT
export const CLIENT_ID = ResourcesConstants.CLIENT_ID
export const DEFAULT_CLIENT_ID = ResourcesConstants.DEFAULT_CLIENT_ID
export const RECURLY_PUBLIC_KEY = ResourcesConstants.RECURLY_PUBLIC_KEY
export const APP_URL = ResourcesConstants.APP_URL
export const HUBSPOT_CLIENT_ID = ResourcesConstants.HUBSPOT_CLIENT_ID
export const MICROSOFT_DYNAMICS_CLIENT_ID =
  ResourcesConstants.MICROSOFT_DYNAMICS_CLIENT_ID
export const SALESFORCE_CLIENT_ID = ResourcesConstants.SALESFORCE_CLIENT_ID
export const SLACK_CLIENT_ID = ResourcesConstants.SLACK_CLIENT_ID
export const MAILCHIMP_CLIENT_ID = ResourcesConstants.MAILCHIMP_CLIENT_ID
export const SEGMENT_ID = ResourcesConstants.SEGMENT_ID
export const SPLIT_ID = ResourcesConstants.SPLIT_ID
export const GROWSUMO_ID = ResourcesConstants.GROWSUMO_ID
export const DRIP_CLIENT_ID = ResourcesConstants.DRIP_CLIENT_ID
export const LINKEDIN_KEY = ResourcesConstants.LINKEDIN_KEY
export const GOOGLE_API_KEY = ResourcesConstants.GOOGLE_API_KEY
export const GOOGLE_CLIENT_ID = ResourcesConstants.GOOGLE_CLIENT_ID
export const MICROSOFT_CALENDAR_CLIENT_ID =
  ResourcesConstants.MICROSOFT_CALENDAR_CLIENT_ID
export const MICROSOFT_ADMIN_CONSENT_CLIENT_ID =
  ResourcesConstants.MICROSOFT_ADMIN_CONSENT_CLIENT_ID
export const WORDPRESS_CLIENT_ID = ResourcesConstants.WORDPRESS_CLIENT_ID
export const SHOPIFY_INTEGRATION_URL =
  ResourcesConstants.SHOPIFY_INTEGRATION_URL
export const DRUPAL_PLUGIN_URL = ResourcesConstants.DRUPAL_PLUGIN_URL
export const FREE_SUPPORT_INBOX_ID = ResourcesConstants.FREE_SUPPORT_INBOX_ID
export const PRESENCE_API_BASE = ResourcesConstants.PRESENCE_API_BASE
export const PRESENCE_WSS_BASE = ResourcesConstants.PRESENCE_WSS_BASE
export const MESSAGES_API_BASE = ResourcesConstants.MESSAGES_API_BASE
export const MESSAGES_WSS_BASE = ResourcesConstants.MESSAGES_WSS_BASE
export const SLACK_INTEGRATION_API = ResourcesConstants.SLACK_INTEGRATION_API

export const WS_CHAT_USE_SHARDS = ResourcesConstants.WS_CHAT_USE_SHARDS
export const WS_LIVE_USE_SHARDS = ResourcesConstants.WS_LIVE_USE_SHARDS
export const WS_CHAT_BASE = ResourcesConstants.WS_CHAT_BASE
export const WS_LIVE_BASE = ResourcesConstants.WS_LIVE_BASE
export const WS_PUSH_BASE = ResourcesConstants.WS_PUSH_BASE
export const WS_NUM_SHARDS = ResourcesConstants.WS_NUM_SHARDS
export const WS_WSS_PROTOCOL = ResourcesConstants.WS_WSS_PROTOCOL
export const WS_API_PROTOCOL = ResourcesConstants.WS_API_PROTOCOL

export const SEGMENT_TRACKING_BLACKLIST =
  ResourcesConstants.SEGMENT_TRACKING_BLACKLIST

export const SALES_INBOX_ID = ResourcesConstants.SALES_INBOX_ID || false
export const SALES_USER_ID = ResourcesConstants.SALES_USER_ID || false

export const AUTH_CLIENT_ID = ResourcesConstants.AUTH_CLIENT_ID

export const SEQUENCE_ENROLL_URL = ResourcesConstants.SEQUENCE_ENROLL_URL

export const CHROME_EXTENSION_LINK =
  'https://chrome.google.com/webstore/detail/drift/obpicmhmbfddhkcbiapfeginbafnjmmm'

export const ONBOARDING_CLP_URL = ResourcesConstants.ONBOARDING_CLP_URL

export const SUPPORT_TICKET_INTERACTION_ID =
  ResourcesConstants.SUPPORT_TICKET_INTERACTION_ID
export const HAS_INTEGRATED_HELP = ResourcesConstants.HAS_INTEGRATED_HELP
export const FREE_USER_INTEGRATED_HELP_INTERACTION_ID =
  ResourcesConstants.FREE_USER_INTEGRATED_HELP_INTERACTION_ID
export const PAID_USER_INTEGRATED_HELP_INTERACTION_ID =
  ResourcesConstants.PAID_USER_INTEGRATED_HELP_INTERACTION_ID

export const HELP_URL = ResourcesConstants.HELP_URL

export const METRICS_API_BASE = ResourcesConstants.METRICS_API_BASE

export const INTEGRATION_INTERACTION_ID =
  ResourcesConstants.INTEGRATION_INTERACTION_I

export const DEVELOPERS_WEB_URL = ResourcesConstants.DEVELOPERS_WEB_URL
export const DRIFT_VIDEO_URL = ResourcesConstants.DRIFT_VIDEO_URL
export const DRIFT_INSIDER_URL = 'https://insider.drift.com/login/'
export const SIFTROCK_URL = 'https://app.siftrock.com/'
export const NOTIFICATION_INTEGRATIONS = [
  'salesforce',
  'marketo',
  'Pardot',
  'hubspot',
  'Eloqua',
]
export const SLACK2_CLIENT_ID = ResourcesConstants.SLACK2_CLIENT_ID
export const MEETINGS_API = ResourcesConstants.MEETINGS_API
export const SALESLOFT_INTEGRATION_API =
  ResourcesConstants.SALESLOFT_INTEGRATION_API
export const SALESLOFT_CLIENT_ID = ResourcesConstants.SALESLOFT_CLIENT_ID
